import { gql } from "@apollo/client";

export const EXCEPTION_REASON_FIELDS = gql`
  fragment ExceptionReasonFields on ExceptionReason {
    id
    code
    name
    description
    finalState
    reattemptConfigs {
      numDays
      dayType
      proofOfDeliveryRequirement
      driverAssignmentType
    }
  }
`;
